import {classNames, observer, pluralize, React, styled} from '@api'
import {Button, Icon, Portal, Slider} from '@blueprintjs/core'
import {Tooltip2} from '@api'
import {Tooltip, Typography} from '@material-ui/core'
import {FormatListNumberedOutlined, FormatListNumberedSharp, SubjectSharp, TableChartOutlined, ViewComfyOutlined, ViewComfySharp, ZoomInOutlined, ZoomOutOutlined} from '@material-ui/icons'
import {CardSizeSlider} from '@modules/contextMenus'
import { ui} from '@stores'
import {PrimaryIconButton} from 'centric-ui-components'
import * as css from './CatalogColumnsSlider.css'

const ColumnsSliderDiv = styled.div`
  margin-left: 16px !important;
  margin-right: 0;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: visible;

  &:hover {
    :global(.bp3-button) {
      opacity: 1;
      pointer-events: auto;
    }
  }

  &:not(:hover) {
    .bp3-button {
      opacity: 0 !important;
    }
  }

  .bp3-slider {
    margin-top: 9px;
    height: 24px;
    overflow: visible;
    
    .bp3-slider-axis {
      display:none;
    }
  }

  .bp3-button {
    top: 38px;
    opacity: 0;
    position: absolute;
    width: calc(100% + 16px);
    left: -8px;
  }
`
export const CatalogColumnSliderBlueprint = observer(() => {
  const {catalog: {settings: {groupBy: {flatModeColumns}}}, groupBy: {maxChildGroupColumns, isProductView, hierarchyGroups, onChangeColumns, settings: {columnView}}} = useStores()

  return isProductView || !hierarchyGroups.some(hg => hg?.isFlat) || columnView
         ? null
         : (
    <ColumnsSliderDiv data-type='Slider' className={css.root}>
      <Slider max={maxChildGroupColumns}
              min={1}
              labelStepSize={1}
              value={flatModeColumns}
              labelRenderer={(v) => <div className={css.sliderLabel}>{v} Column</div>}
              onChange={v => onChangeColumns(null, v)}/>
    </ColumnsSliderDiv>
  )
})

// <div className={css.sliderLabel}>{v} Column</div>}

import {Slider as MaterialSlider} from '@material-ui/core'
import { useStores } from '@design-board'
export const CatalogColumnSliderMaterial : React.FunctionComponent<{ className?: string }> & { css?: typeof css } = observer<{className?: string}>(function CatalogColumnSliderMaterial({className}) {
  const {catalog: {assortments, canShowColumnsSlider, settings: {groupBy: {flatModeColumns}}}, groupBy: {maxChildGroupColumns, onChangeColumns, onClickLessColumns, onClickMoreColumns}} = useStores(),
    {css: sliderCss} = CardSizeSlider

  if (assortments?.hideCatalogSpecificWidgets) {
    return null
  }
  return !canShowColumnsSlider
         ? null
         : (
           <div className={classNames(sliderCss.sliderToolbarPanel, className)}
                //onDoubleClick_forTabNode={catalog.resetCardSize}
           >
             <Tooltip title='Less Columns'>
               <PrimaryIconButton icon={<SubjectSharp />} onClick={onClickLessColumns} />
             </Tooltip>

             <Tooltip placement='bottom' title={`${flatModeColumns} ${pluralize('Column', flatModeColumns)}`}>
             <MaterialSlider
               classes={{ thumb: sliderCss.thumb, active: sliderCss.active}}
               className={sliderCss.materialSlider}
               aria-labelledby='number-of-columns'
               max={maxChildGroupColumns}
               min={1}
               // marks={[{value: 1, label: '1'}, {value: 2, label: '2'}, {value:3, label: '3'}, {value:4, label: '4'}, {value: 5, label: '5'}]}
               value={flatModeColumns}
               valueLabelDisplay='off'
               color='secondary'
               onChange={(e, v: number) => onChangeColumns(e, v)}/>
            </Tooltip>

             <Tooltip title='More Columns'>
               <PrimaryIconButton icon={<ViewComfySharp />} onClick={onClickMoreColumns}/>
             </Tooltip>
           </div>
         )
})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/Menus/Toolbar/CatalogColumnsSlider.tsx